// Externe Bibliotheken
import React from 'react';
import { Navigate } from 'react-router';

const NotFound = () => {
    return <Navigate to={'/'} />;
};

export default NotFound;
